import ConnectionsPage from "./components/Connections/ConnectionsPage";

const MetaCallback = () => <ConnectionsPage callbackPlatform="meta" />;

export default MetaCallback;
